import { LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ReportsPrintView = angular
  .module('acme.view.application.reports.print', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.view.application.reports.print.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const reportsPrint = {
        name: 'application.reports.print',
        url: '/print',
        abstract: true,
        views: {
          'main@': {
            controller: 'ReportsPrintController',
            templateUrl: 'layouts/print.tpl.html',
          },
        },
      },
      reportsPrintDefault = {
        name: 'application.reports.print.default',
        url: '',
        views: {
          'subview-main': {
            templateUrl: 'views/application/views/reports/print/print.tpl.html',
          },
        },
        data: {
          pageTitle: 'Print Report',
          /** Secure With Roles **/
          roles: ['user', 'admin'],
        },
        resolve: {
          JQueryPrint: LoadScriptResolver({ id: 'jquery-print', url: '/assets/jquery-print.js' }),
        },
      };

    $stateProvider.state(reportsPrint).state(reportsPrintDefault);
  }).name;
